import { memo } from 'react';

import { type Board } from '@air/types';

import {
  LocationsFilterBoardTreeItem,
  type LocationsFilterBoardTreeItemProps,
} from '~/components/Filters/LocationsFilter/LocationsFilterBoardTreeItem';
import { type LocationsFilterBoard } from '~/components/Filters/LocationsFilter/useLocationsFilterData';

export type LocationsFilterBoardTreeProps = Pick<LocationsFilterBoardTreeItemProps, 'locked' | 'onBoardSelect'> & {
  boards: (Board | LocationsFilterBoard)[];
  hierarchyAncestorTitles?: string[];
};

const EMPTY_ANCESTOR_TITLES: string[] = [];

export const LocationsFilterBoardTree = memo(
  ({
    boards,
    hierarchyAncestorTitles = EMPTY_ANCESTOR_TITLES,
    locked,
    onBoardSelect,
  }: LocationsFilterBoardTreeProps) => {
    return (
      <div data-testid="LOCATIONS_FILTER_BOARD_TREE">
        {boards.map((board) => (
          <LocationsFilterBoardTreeItem
            key={board.id}
            board={board}
            hierarchyAncestorTitles={hierarchyAncestorTitles}
            locked={locked}
            onBoardSelect={onBoardSelect}
          />
        ))}
      </div>
    );
  },
);

LocationsFilterBoardTree.displayName = 'LocationsFilterBoardTree';
